<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center">
      <div class="col-lg-10">
        <h1 class="heading-color text-center p-5">
          {{categoryName}} <span v-if="categoryName !== 'Spec Sheet' && categoryName !== 'Combo Pallets'">Products</span>
        </h1>
      </div>
    </div>
    <div class="row d-flex justify-content-center" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="col-lg-10">
        <div class="overlay">
          <div class="main-loader">
            <MainLoader></MainLoader>
          </div>
        </div>
        <div class="row" v-if="this.products.length">
          <ItemCard v-for="product in products" :key="product.id" :item="product" :nextLink="'/product/' + product.id + '/images'"></ItemCard>
        </div>
        <div class="not-found-div" v-else>
          <div class="row">
            <div class="col-md-12">
              <p class="text-center">No products found in {{categoryName}} category</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
import Product from '@/models/Product'
import ItemCard from '@/components/ItemCard'
export default {
  name: 'Products',
  components: {
    ItemCard
  },
  watch: {
    '$route.params.category_id': function () {
      this.fetchProducts()
    }
  },
  data () {
    return {
      products: [],
      categoryName: ''
    }
  },
  mounted () {
    this.fetchProducts()
  },
  methods: {
    fetchProducts () {
      this.products = []
      $('.overlay').removeClass('d-none')
      this.$store.dispatch('fetchProducts', this.$route.params.category_id)
        .then((result) => {
          result.data.products.forEach(product => {
            this.products.push(new Product(product))
          })
          $('.overlay').addClass('d-none')
          this.categoryName = result.data.category_name
          document.title = 'Img-Lib - ' + this.categoryName + ' products'

          if (this.categoryName.includes('Spec Sheet') && this.products.length) {
            this.$router.push('/product/' + this.products[0].id + '/images')
          }
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}

</script>

<style scoped>
.not-found-div {
  height: calc(70vh - 190px);
}
@media screen and (max-width: 500px){
  .not-found-div {
    height: calc(70vh - 100px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Products.vue